// extracted by mini-css-extract-plugin
export default {"container":"InfiniteCalendarSeries-rebranded-module__container___1KF1O","headerText":"InfiniteCalendarSeries-rebranded-module__headerText___1ZkVf"};